import { Alignment, CellPanel, CellRenderer, DotRenderer, RowPanel } from '@blk/simba';
import { ColorsConfig } from '@ddt-web/config';
import { CellData } from '@ddt-web/data-service';

export class PortfolioOccurrenceRenderer implements CellRenderer {
	constructor(
		private cells: Array<CellData>,
		private noOfResultedColumns: number,
		private hAlign: Alignment.Horizontal,
		private widthProportion: number
	) { }

	public render(): CellPanel {
		const endNumber = this.cells.length;
		return new CellPanel(
			[
				new RowPanel(
					'occurrence',
					this.cells
						.filter((cell: CellData) => cell.config && cell.config.visible)
						.slice(this.noOfResultedColumns - 1, endNumber)
						.map(
							(cell: CellData, i: number, arr: Array<CellData>) =>
								new CellPanel(
									Number(cell.rawValue) > 0 ? [new DotRenderer(ColorsConfig.PORTFOLIO_COLORS[i])] : [],
									{ proportion: 100 / arr.length },
									Alignment.Horizontal.Center
								)
						),
					{ paddingLeft: 4 }
				)
			],
			{ proportion: this.widthProportion },
			this.hAlign
		);
	}
}
